import React from 'react';
import cn from 'classnames';

import { useTheme } from 'providers/Theme.provider';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import C from 'utils/values/constant.util';

import CN from './SidebarSkeleton.module.scss';

const VARIANT = C({
  row: 'row',
  basic: 'basic', // TODO: a basic option
  header: 'header',
  content: 'content',
  footer: 'footer',
  toolbar: 'toolbar',
});

const SkeletonBox = ({ size, height }) => (
  <div
    className={cn({
      [CN.skeletonBox]: true,
      [CN[`${size}Size`]]: size,
      [CN[`${height}Height`]]: height,
    })}
  />
);

const SkeletonRow = () => (
  <div className={CN.skeletonRow}>
    <SkeletonBox size="md" height="md" />
    <SkeletonBox size="sm" height="sm" />
    <SkeletonBox size="sm" height="sm" />
  </div>
);

const SidebarSkeleton = ({ tag, variant }) => {
  const { isDarkMode } = useTheme();

  return (
    <div
      data-bem="SidebarSkeleton"
      data-tag={fromAnyToTrimmed(tag)}
      className={cn({
        [CN.component]: true,
        [CN[`${variant}Variant`]]: variant,
        [CN.dark]: isDarkMode,
      })}
    >
      {variant === VARIANT.header && <SkeletonBox size="lg2" height="lg2" />}

      {variant === VARIANT.content && (
        <div className={CN.contentLines}>
          <SkeletonBox size="lg" height="md" />
          <SkeletonRow />
          <SkeletonRow />
        </div>
      )}

      {variant === VARIANT.footer && (
        <div className={CN.contentLines}>
          <SkeletonBox size="lg" height="sm" />
          <SkeletonBox size="lg" height="lg" />
        </div>
      )}
      {variant === VARIANT.toolbar && (
        <div className={CN.contentToolbar}>
          <SkeletonBox size="lg" height="lg" />
          <SkeletonBox size="lg" height="lg" />
          <SkeletonBox size="lg" height="lg" />
          <SkeletonBox size="lg" height="lg" />
        </div>
      )}

      {variant === VARIANT.row && (
        <div className={CN.contentLines}>
          <SkeletonRow />
          <SkeletonRow />
          <SkeletonRow />
        </div>
      )}
    </div>
  );
};

export default SidebarSkeleton;
